export default {
  apiUrl: process.env.VUE_APP_API_ENDPOINT || 'http://localhost:3000',
  // apiUrl: 'https://us-central1-skillsmatrix.cloudfunctions.net/api',
  // apiUrl: 'http://localhost:3000/skillsmatrix/us-central1/api',
  googleClientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
};
